// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'ID',
        isSortable: true
      },
      {
        title: 'Учередитель',
        isSortable: false
      },
      {
        title: 'Сумма',
        isSortable: true
      },
      {
        title: 'Дата выгрузки',
        isSortable: true
      },
      {
        title: 'Назначение платежа',
        isSortable: true
      }
    ]
  },
  statuses: [
    {
      id: 1,
      isControlsActive: false,
      isActive: false,
      name: 'ММК ПАО',
      sum: '453850.23',
      date: '13 янв. 2020 г.',
      appointment: 'Оплата за выполненные работы по УКСу по сч/ф 2050, 2054, 2055, 2085, 2092, 2102, 2103 за НОЯБРЬ 2019г по договору 240326 от 18.09.2019 в т.ч. НДС-75641.71'
    },
    {
      id: 2,
      isControlsActive: false,
      isActive: false,
      name: 'НОВ Ойлфилд Сервисез Восток',
      sum: '144000',
      date: '14 янв. 2020 г.',
      appointment: 'Оплата по сф 2283 от 29.11.2019 за калибратор по дог 759-vu от 18.09.19, сумма 144000-00, в т. ч. НДС 24000-00'
    },
    {
      id: 3,
      isControlsActive: false,
      isActive: false,
      name: 'НОВ Ойлфилд Сервисез Восток',
      sum: '6000',
      date: '16 янв. 2020 г.',
      appointment: 'Оплата по сф 2005 от 31.10.19 за ДОД и переводник по дог 759-vu от 18.09.19. Сумма 487512-00,в тч НДС 81 252-00'
    }
  ],
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true
})

const getters = {
  getUnloadingStatusList: state => state.statuses,
  getUnloadingStatusListTableHeaders: state => state.tableHeaders,
  getUnloadingStatusListSearchValue: state => state.searchValue,
  getUnloadingStatusListFilter: state => state.filter,
  getUnloadingStatusListPagination: state => state.pagination
}

const mutations = {
  GET_UNLOADING_STATUS: (state, statuses) => {
    state.statuses = statuses.map(status => {
      return {
        ...status,
        isControlsActive: false,
        isActive: true
      }
    })
    state.isLoading = false
  },
  TOGGLE_UNLOADING_STATUS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.statuses.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  SET_UNLOADING_STATUS_ITEM_VALIDATION: (state, valid) => {
    // validation set
  },
  // pagination
  SET_UNLOADING_STATUS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  TOGGLE_UNLOADING_STATUS_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_UNLOADING_STATUS_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  },
  RESET_UNLOADING_STATUS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_UNLOADING_STATUS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_UNLOADING_STATUS_LIST_FILTER: (state) => {
    state.filter.active = !state.filter.active
  }
}

const actions = {
  getUnloadingStatus ({ commit, state }) {
    /* const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const filter = ''
    const searchFilter = state.searchValue ? `search[any]=${state.searchValue}` : ''
    const expands = 'expand='

    axios.get(`${url}/contractors?orderBy=created_at&orderDir=DESC&per-page=${currentTake}&page=${currentPage}&${expands}&${filter}&${searchFilter}`, config).then(response => {
      commit('GET_CONTRACTORS', response.data.data)
      commit('SET_CONTRACTORS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    }) */
  },
  toggleUnloadingStatusListItemControls ({ commit }, itemId) {
    commit('TOGGLE_UNLOADING_STATUS_LIST_ITEM_CONTROLS', itemId)
  },
  setUnloadingStatusItemName ({ commit }, value) {
    commit('SET_UNLOADING_STATUS_ITEM_NAME', value)
  },

  // pagination
  toggleUnloadingStatusListPageList ({ commit }) {
    commit('TOGGLE_UNLOADING_STATUS_LIST_PAGE_LIST')
  },
  getUnloadingStatusListPrevPage ({ state, commit }) {
    console.log('prev page')
  },
  getUnloadingStatusListNextPage ({ state, commit }) {
    console.log('next page')
  },
  getUnloadingStatusListPage ({ state, commit }, pageNum) {
    console.log(pageNum)
  },
  resetUnloadingStatusListCurrentPage ({ commit }) {
    commit('RESET_UNLOADING_STATUS_LIST_CURRENT_PAGE')
  },

  // search
  setUnloadingListSearchValue ({ commit }, searchValue) {
    commit('SET_UNLOADING_STATUS_LIST_SEARCH_VALUE', searchValue)
    this.dispatch('getUnloading')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
